import { useCallback, useState } from 'react'

import { useNavigate } from 'react-router'

import { routes } from '../../../routes'
import { AgreementParams, toStrictly } from '../entity'
import { create, fetch } from '../request'

export const useAgreement = () => {
  const [requesting, setRequesting] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  const navigate = useNavigate()

  const fetchAgreements = useCallback(async (): Promise<AgreementParams> => {
    const fetched = await fetch()
    return {
      agreeTermsOfService: fetched.agreeTermsOfService,
      agreePrivacyPolicy: fetched.agreePrivacyPolicy,
      agreeExternalTransmissionPolicy: fetched.agreeExternalTransmissionPolicy,
    }
  }, [])

  const handleAgreementCheck = async (): Promise<boolean> => {
    const fetched = await fetchAgreements()

    const allAgreed =
      fetched.agreePrivacyPolicy &&
      fetched.agreeTermsOfService &&
      fetched.agreeExternalTransmissionPolicy

    if (!allAgreed) {
      navigate(routes.agreement)
      return true
    }

    return false
  }

  const submit = async (params: Partial<AgreementParams>): Promise<void> => {
    try {
      setRequesting(true)
      setErrorMessage(null)
      await create(toStrictly(params))
    } catch (_error) {
      setErrorMessage('リクエストに失敗しました。')
    } finally {
      setRequesting(false)
    }
  }

  return {
    handleAgreementCheck,
    fetchAgreements,
    submit,
    requesting,
    errorMessage,
  }
}
